import { useContext } from "react";

import { MediaPreviewModalContext } from "./MediaPreviewModalProvider";

export const useMediaPreviewModal = () => {
  const context = useContext(MediaPreviewModalContext);

  if (!context) {
    throw new Error(
      "useMediaPreviewModal must be used within a MediaPreviewModalProvider",
    );
  }

  return context;
};
